/** @module Sourcing/DeleteSRLineItem */
define([
	"dojo/_base/declare",
	"csi/xml",
	"./DeleteSRBase"
], function(declare,xml,DeleteSRBase) {

	return declare(DeleteSRBase, {
		/**
		 * Replace "Save" with "Delete" button
		 * @param {View} defView
		 * @param {Action[]} defActions
		 */
		addProxyActions: function(defView, defActions) {
			defActions.addAction(this.getProxyAction("BUTTON_DELETE", true));
			this.inherited(arguments);
		},

		appendSupplierItemQuery: function(q) {
			q.RefAttr("QuoteSRLineItem", xml.OP_EQUALS, this.m_urlNode);
		},

		appendSampleQuery: function(q) {
			q.RefAttr("SampleSRLineItem", xml.OP_EQUALS, this.m_urlNode);
		}
	});
});
